import { render, staticRenderFns } from "./manquants.vue?vue&type=template&id=74584cd6"
import script from "./manquants.vue?vue&type=script&lang=js"
export * from "./manquants.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports